module.exports = __webpack_public_path__ + "static/media/pause-toggle-w64.7dc7285f.svg";